import { useAuthFetchWithResponse } from '@e3dc-react/shell/Hooks/AuthFetch'
import { UseQueryResult } from '@tanstack/react-query'
import { isUndefined } from 'lodash'
import { scanEmcFarm } from '../api/scan-emc-farm.api'
import { NetworkScanModel } from 'src/Routes/Installation/InstallationModel'
import { usePortalQuery } from 'src/Libs/api'

/** Hook to fetch the farm network scan result for a specific EMC device */
export const useFetchScanEmcFarm = (installationId: number | null, emcId: string | undefined): UseQueryResult<NetworkScanModel[], Error> => {
  const authFetch = useAuthFetchWithResponse()

  return usePortalQuery({
    queryKey: ['installation', installationId, 'emc', emcId, 'scan-farm'],
    queryFn: async () => {
      if (installationId === null || emcId === undefined) {
        throw new Error('Query called without required params')
      }
      const { value, error, hasErrors } = await scanEmcFarm(installationId, emcId, authFetch)
      if (hasErrors) {
        throw error
      }
      return value
    },
    enabled: !!installationId && !isUndefined(emcId),
    staleTime: 0,
  })
}
